<mat-card class="detail-card" valumizeCardContextMenu [commentScope]="'fund-report-valuation-deal-seller'" [commentSlug]="'fund-seller-position'">
  <mat-card-header class="detail-card-header">
    <mat-card-title data-test="title">Seller Position</mat-card-title>
  </mat-card-header>
  <mat-card-subtitle>
    @if ((fundSellerPosition$ | async); as fundSellerPosition) {
      @if (fundSellerPosition.sellerPosition.status === 'ERROR') {
        <valumize-info-panel [appearance]="'ERROR'"
        [message]="fundSellerPosition.sellerPosition.errorMessage"></valumize-info-panel>
      }
      @if (fundSellerPosition.sellerPosition.status === 'SAVED') {
        <valumize-info-panel [appearance]="'SAVED'"
        [message]="'Seller Position successfully saved'"></valumize-info-panel>
      }
    }
    @if (isFundSizeZero$ | async) {
      <valumize-info-panel [appearance]="'WARNING'"
        [message]="'Fund size is 0 — percentage and bid calculations will be impacted.'">
      </valumize-info-panel>
    }
  </mat-card-subtitle>
  @if (dealId$ | async; as dealId) {
    @if (fundSellerPosition$ | async; as fundSellerPosition) {
      <mat-card-content class="detail-card-content">
        <form [formGroup]="sellerPositionForm">
          <div class="key-value-pair-section">
            <div class="key-value-pair-column">
              <div>
                <h3 data-test="subtitle-commitment">Commitment</h3>
                <div class="key-value-pair">
                  <div class="key-value-item required-asterisk">Original Commitment</div>
                  <div class="key-value-item">
                    @if (!isEditable) {
                      {{fundSellerPosition.sellerPosition.data.sellerCommitment | traceableFormat}}
                    } @else {
                        <input matInput type="number" class="input-number-narrow" formControlName="originalCommitment" id="originalCommitment">
                    }
                  </div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Expired Released Commitments</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.expiredReleasedCommitments | traceableFormat}}</div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Drawn Commitments</div>
                  <div class="key-value-item">
                    @if (!isEditable) {
                      {{fundSellerPosition.sellerPosition.data.drawnCommitments | traceableFormat}}
                      @if (fundSellerPosition.sellerPosition.data.drawnCommitmentsCalculated?.amount !== null
                           && fundSellerPosition.sellerPosition.data.drawnCommitments.source === 'user') {
                        <div class="calc-hint">Calc: {{fundSellerPosition.sellerPosition.data.drawnCommitmentsCalculated | traceableFormat}}</div>
                      }
                    } @else {
                      <input matInput type="number" class="input-number-narrow" formControlName="drawnCommitments" id="drawnCommitments">
                    }
                  </div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Distributions</div>
                  <div class="key-value-item">
                    @if (!isEditable) {
                      {{fundSellerPosition.sellerPosition.data.distributions | traceableFormat}}
                      @if (fundSellerPosition.sellerPosition.data.distributionsCalculated?.amount !== null
                           && fundSellerPosition.sellerPosition.data.distributions.source === 'user') {
                        <div class="calc-hint">Calc: {{fundSellerPosition.sellerPosition.data.distributionsCalculated | traceableFormat}}</div>
                      }
                    } @else {
                      <input matInput type="number" class="input-number-narrow" formControlName="distributions" id="distributions">
                    }
                  </div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Account Balance Before Carry</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.accountBalanceBeforeCarry | traceableFormat}}</div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Realized Carried Interest</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.realizedCarriedInterest | traceableFormat}}</div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Total Carried Interest</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.totalCarriedInterest | traceableFormat}}</div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">GP Valuation</div>
                  <div class="key-value-item">
                    @if (!isEditable) {
                      {{fundSellerPosition.sellerPosition.data.gpValuation | traceableFormat}}
                      @if (fundSellerPosition.sellerPosition.data.gpValuationCalculated?.amount !== null
                           && fundSellerPosition.sellerPosition.data.gpValuation.source === 'user') {
                        <div class="calc-hint">Calc: {{fundSellerPosition.sellerPosition.data.gpValuationCalculated | traceableFormat}}</div>
                      }
                    } @else {
                      <input matInput type="number" class="input-number-narrow" formControlName="gpValuation" id="gpValuation">
                    }
                  </div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Adjusted Commitment</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.adjustedCommitment | traceableFormat}}</div>
                </div>
<!--                <div class="key-value-pair">-->
<!--                  <div class="key-value-item">Post-ref Drawdowns</div>-->
<!--                  <div class="key-value-item">-->
<!--                      @if (!isEditable) {-->
<!--                          {{fundSellerPosition.sellerPosition.data.postRefDrawdowns | traceableFormat}}-->
<!--                      } @else {-->
<!--                          <input matInput type="number" class="input-number-narrow" formControlName="postRefDrawdowns" id="postRefDrawdowns">-->
<!--                      }-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="key-value-pair">-->
<!--                  <div class="key-value-item">Post-ref Distributions</div>-->
<!--                  <div class="key-value-item">-->
<!--                      @if (!isEditable) {-->
<!--                          {{fundSellerPosition.sellerPosition.data.postRefDistributions | traceableFormat}}-->
<!--                      } @else {-->
<!--                          <input matInput type="number" class="input-number-narrow" formControlName="postRefDistributions" id="postRefDistributions">-->
<!--                      }-->
<!--                  </div>-->
<!--                </div>-->
                <div class="key-value-pair">
                  <div class="key-value-item">Final Adjusted Commitment (Net Of CFs)</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.finalAdjustedCommitment | traceableFormat}}</div>
                </div>
              </div>
            </div>
            <div class="key-value-pair-column">
              <div>
                <h3 data-test="subtitle-undrawn">Undrawn</h3>
                <div class="key-value-pair">
                  <div class="key-value-item">
                    Calculated Undrawn
                    <mat-icon
                      class="info-icon"
                      matTooltip="Calculated Undrawn = Commitments − Drawdowns"
                      matTooltipPosition="right">
                      info_outline
                    </mat-icon>
                  </div>
                  <div class="key-value-item">
                    {{fundSellerPosition.sellerPosition.data.calculatedUndrawn | traceableFormat}}
                  </div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Recallable Distribution</div>
                  <div class="key-value-item">
                    @if (!isEditable) {
                      {{fundSellerPosition.sellerPosition.data.recallableDistribution | traceableFormat}}
                      @if (fundSellerPosition.sellerPosition.data.recallableDistributionCalculated?.amount !== null
                           && fundSellerPosition.sellerPosition.data.recallableDistribution.source === 'user') {
                        <div class="calc-hint">Calc: {{fundSellerPosition.sellerPosition.data.recallableDistributionCalculated | traceableFormat}}</div>
                      }
                    } @else {
                        <input matInput type="number" class="input-number-narrow" formControlName="recallableDistribution" id="recallableDistribution">
                    }
                  </div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Total Undrawn</div>
                  <div class="key-value-item">
                      {{fundSellerPosition.sellerPosition.data.totalUndrawn | traceableFormat}}
                  </div>
                </div>
                <h3 data-test="subtitle-bidprice">Bid Price</h3>
<!--                <div class="key-value-pair">-->
<!--                  <div class="key-value-item">Finder's Fee</div>-->
<!--                  <div class="key-value-item">-->
<!--                      @if (!isEditable) {-->
<!--                          {{fundSellerPosition.sellerPosition.data.findersFee | traceableFormat}}-->
<!--                      } @else {-->
<!--                          <input matInput type="number" class="input-number-narrow" formControlName="findersFee" id="findersFee">-->
<!--                      }-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="key-value-pair">-->
<!--                  <div class="key-value-item">Gross</div>-->
<!--                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.grossBidPrice | traceableFormat}}</div>-->
<!--                </div>-->
                <div class="key-value-pair">
                  <div class="key-value-item">Bid Price</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.netBidPrice | traceableFormat}}</div>
                </div>
              </div>
            </div>
            <div class="key-value-pair-column">
              <div>
                <h3 data-test="subtitle-summary">Summary</h3>
                <div class="key-value-pair">
                  <div class="key-value-item">% of fund held</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.percentageOfFundHeld | traceableFormat}}</div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Drawdown</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.drawdown | traceableFormat}}</div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">DPI</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.dpi | traceableFormat}}</div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">TVPI</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.tvpi | traceableFormat}}</div>
                </div>
                <div class="key-value-pair">
                  <div class="key-value-item">Seller Multiple TVPI</div>
                  <div class="key-value-item">{{fundSellerPosition.sellerPosition.data.sellerMultipleTVPI | traceableFormat}}</div>
                </div>
              </div>
            </div>
          </div>
        </form>
        @if (documentContext) {
          <div class="key-value-pair-section">
            <div class="capital-account-statement-section">
              <h3>Capital Account Statement</h3>
              <valumize-document [context]="documentContext"></valumize-document>
            </div>
          </div>
        }
      </mat-card-content>
    }
    <mat-card-actions class="detail-card-actions">
      @if (!isEditable) {
        <button (click)="editMode()"
          [disabled]="(isEditDisabled$ | async)!"
          color="primary"
          data-test="edit-button"
          mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
      }
      @if (fundValuationId$ | async; as fundValuationId) {
        @if (isEditable) {
          <button (click)="save(dealId, fundValuationId)"
            [disabled]="sellerPositionForm.invalid"
            color="primary"
            data-test="save-button"
            mat-icon-button>
            <mat-icon>save</mat-icon>
          </button>
        }
        @if (!isEditable && hasOverride) {
          <button (click)="resetToCalculated(dealId, fundValuationId)"
            color="primary"
            data-test="reset-to-calculated-button"
            mat-stroked-button>
            <mat-icon>restart_alt</mat-icon>
            Reset to Calculated
          </button>
        }
      }
      @if (isEditable) {
        <button (click)="cancel()"
          color="primary"
          data-test="cancel-button"
          mat-icon-button>
          <mat-icon>cancel</mat-icon>
        </button>
      }
      <valumize-card-comments-button [commentScope]="'fund-report-valuation-deal-seller'" [commentSlug]="'fund-seller-position'"></valumize-card-comments-button>
    </mat-card-actions>
  } @else {
    <mat-card-content class="detail-card-content" style="color: grey">
      Please select deal first!
    </mat-card-content>
  }
</mat-card>
